import {lazy} from 'react';

import Roles from '../contants/Roles';
import SupportingMaterial from '../pages/Private/SupportingMaterial';
import SupportingMaterialAdmin from '../pages/Private/SupportingMaterialAdmin';
import SupportingMaterialSubCategoryAdmin from '../pages/Private/SupportingMaterialAdmin/SupportingMaterialSubCategoryAdmin';

const Settings = lazy(() => import('./../pages/Private/Settings'));
const Dashboard = lazy(() => import('../pages/Private/Dashboard'));
const Profile = lazy(() => import('../pages/Private/Profile'));
const AccessDenied = lazy(() => import('../pages/Private/AccessDenied'));
const OpportunityForm = lazy(() => import('../pages/Private/OpportunityForm'));
const Notify = lazy(() => import('../pages/Private/Notify'));
const LeadsEdit = lazy(() => import('../pages/Private/LeadsEdit'));
const LeadsDetail = lazy(() => import('../pages/Private/LeadsDetail/index'));
const LeadsBoard = lazy(() => import('../pages/Private/LeadsBoard'));
const OpportunityNew = lazy(() => import('../pages/Private/OpportunityForm/OpportunityNew'));
const Goal = lazy(() => import('../pages/Private/Goal'));
const GoalNewMenu = lazy(() => import('../pages/Private/GoalNew'));
const GoalNewProposal = lazy(() => import('../pages/Private/GoalNewProposal'));
const GoalNewProposalCompleted = lazy(() => import('../pages/Private/GoalNewProposalCompleted'));
const GoalNewSales = lazy(() => import('../pages/Private/GoalNewSales'));
const SalesChart = lazy(() => import('../pages/Private/SalesChart'));
const ProposalDetailType = lazy(() => import('../pages/Private/Proposal/Proposal-detail-type'));
const ProposalDetailStatus = lazy(() => import('../pages/Private/Proposal/Proposal-detail-Status'));
const ProposalDetail = lazy(()=> import('../pages/Private/Proposal/Proposal-detail'));
const MyProposal = lazy(()=> import('../pages/Private/Proposal/My-Proposal'));
const ProposalBowe = lazy(()=> import('../pages/Private/Proposal/ProposalAction/Bowe'));
const Client = lazy(()=> import('../pages/Private/Client'));
const Sac = lazy(()=> import('../pages/Private/Sac'));
const GenericNotification = lazy(()=> import('../pages/Private/GenericNotification'));
const ReportMonthlyEarnings = lazy(()=> import('../pages/Private/ReportMonthlyEarnings'));
const ZeeShop = lazy(()=> import('../pages/Private/ZeeShop'));
const Consultants = lazy(()=> import('../pages/Private/Consultants'));
const ReportLeads = lazy(()=> import('../pages/Private/ReportLeads'));
const GeneralSearch = lazy(()=> import('../pages/Private/GeneralSearch'));
const BannerPopUpAdmin = lazy(() => import('../pages/Private/BannerPopUpAdmin'));
const HeadOffice = lazy(() => import('../pages/Private/AuthorizedStore/HeadOffice'));
const BranchOffice = lazy(() => import('../pages/Private/AuthorizedStore/BranchOffice'));
const Seller = lazy(() => import('../pages/Private/AuthorizedStore/Seller'));
const AuthorizedStore = lazy(() => import('../pages/Private/AuthorizedStore'));
const PartnerWebHook = lazy(() => import('../pages/Private/Partner/PartnerWebHook'));
const PartnerStatusAndSubStatus = lazy(() => import('../pages/Private/Partner/PartnerStatusAndSubStatus'));

interface IPrivateRoute {
    browserTitle: string;
    colorBackgroundHeader?:string;
    path: string;
    customPage?: boolean;
    page: any;
    pageTitle?: string;
    roles: Roles[];
}

const rolesEveryone = [Roles.User, Roles.Admin, Roles.Manager, Roles.Consultant, Roles.Master, Roles.Marketing];

const routes: Array<IPrivateRoute> = [
    {
        path: '/403',
        browserTitle: 'Acesso negado',
        page: AccessDenied,
        roles: rolesEveryone
    },
    {
        path: "/settings",
        browserTitle: 'Configurações',
        page: Settings,
        roles: [Roles.Admin]
    },
    {
        path: "/dashboard",
        browserTitle: 'Dashboard',
        pageTitle: 'Bem-vindo!',
        page: Dashboard,
        roles: rolesEveryone
    },
    {
        path: '/profile',
        browserTitle: 'Perfil',
        page: Profile,
        roles: rolesEveryone
    },
    {
        path: '/opportunity-form',
        browserTitle: 'Proposta',
        colorBackgroundHeader:"#2e247a",
        page: OpportunityForm,
        roles: [Roles.Consultant, Roles.Seller]
    },
    {
        path: '/zee-shop',
        browserTitle: 'Zee Shop',
        colorBackgroundHeader:"#2e247a",
        page: ZeeShop,
        roles: [Roles.Consultant]
    },
    {
        path: '/my-proposal',
        browserTitle: 'Minhas Proposta',
        colorBackgroundHeader:"#2e247a",
        page: MyProposal,
        roles: [Roles.Admin, Roles.Consultant, Roles.Seller]
    },
    {
        path: '/my-proposal/:search',
        browserTitle: 'Minhas Proposta',
        colorBackgroundHeader:"#2e247a",
        page: MyProposal,
        roles: [Roles.Admin, Roles.Consultant, Roles.Seller]
    },
    {
        path: '/notify/:key',
        browserTitle: 'Notificações',
        page: Notify,
        roles: rolesEveryone
    },
    {
        path: '/notify',
        browserTitle: 'Notificações',
        page: Notify,
        roles: rolesEveryone
    },
    {
        path: '/leads/details/:id',
        browserTitle: 'Leads',
        page: LeadsDetail,
        roles: [Roles.Consultant]
    },
    {
        path: '/leads/edit/:id?',
        browserTitle: 'Leads',
        page: LeadsEdit,
        roles: [Roles.Consultant]
    },
    {
        path: '/leads',
        browserTitle: 'Leads',
        page: LeadsBoard,
        roles: [Roles.Consultant]
    }, {
        path: '/OpportunityReviewKit/:id/:proposalId',
        browserTitle: 'Revisar',
        colorBackgroundHeader:"#2e247a",
        page: OpportunityNew,
        roles: [Roles.Consultant, Roles.Seller]
    }, {
        path: '/OpportunityNew/:id/:group',
        browserTitle: 'Tipo Proposta',
        colorBackgroundHeader:"#2e247a",
        page: OpportunityNew,
        roles: [Roles.Consultant, Roles.Seller]
    },
    {
        path: '/OpportunityNew/:id',
        browserTitle: 'Criar Proposta',
        colorBackgroundHeader:"#2e247a",
        page: OpportunityNew,
        roles: [Roles.Consultant, Roles.Seller]
    }, {
        path: '/SalesChart',
        browserTitle: 'Gráfico de Vendas',
        colorBackgroundHeader:"#2e247a",
        page: SalesChart,
        roles: [Roles.Admin, Roles.Consultant]
    },
    {
        path: '/goals/new/proposal/completed/:id?',
        browserTitle: 'Nova meta',
        page: GoalNewProposalCompleted,
        roles: [Roles.Consultant],
    },
    {
        path: '/goals/new/proposal/:id?',
        browserTitle: 'Nova meta',
        page: GoalNewProposal,
        roles: [Roles.Consultant],
    },
    {
        path: '/goals/new/bonus/:id?',
        browserTitle: 'Nova meta',
        page: GoalNewSales,
        roles: [Roles.Consultant],
    },
    {
        path: '/goals/new',
        browserTitle: 'Nova meta',
        page: GoalNewMenu,
        roles: [Roles.Consultant],
    },
    {
        path: '/goals',
        browserTitle: 'Metas',
        page: Goal,
        roles: [Roles.Consultant],
    },
    {
        path: '/Proposal-detail-Status/:id',
        browserTitle: 'Detalhes',
        colorBackgroundHeader:"#2e247a",
        page: ProposalDetailStatus,
        roles: [Roles.Consultant, Roles.Seller]
    },
    {
        path: '/proposal-detail-type/:id/:status/:subStatus',
        browserTitle: 'Detalhes',
        colorBackgroundHeader:"#2e247a",
        page: ProposalDetailType,
        roles: [Roles.Consultant, Roles.Seller]
    },
    {
        path: '/proposal-detail-type/:id/:status',
        browserTitle: 'Detalhes',
        colorBackgroundHeader:"#2e247a",
        page: ProposalDetailType,
        roles: [Roles.Consultant, Roles.Seller]
    },
    {
        path: '/proposal-detail/:id',
        browserTitle: 'Proposta',
        colorBackgroundHeader:"#2e247a",
        page: ProposalDetail,
        roles: [Roles.Admin, Roles.Consultant, Roles.Seller]
    },
    {
        path: '/ProposalActionBowe/:id',
        browserTitle: 'Aceite',
        page: ProposalBowe,
        roles: [Roles.Consultant, Roles.Seller]
    },
    {
        path: '/Client',
        browserTitle: 'Clientes',
        page: Client,
        roles: [Roles.Consultant]
    },
    {
        path: '/sac',
        browserTitle: 'Ajuda',
        page: Sac,
        roles: rolesEveryone
    },
    {
        path: '/generic/:id',
        browserTitle: 'Processando Notificações',
        page: GenericNotification,
        roles: rolesEveryone

    }, {
        path: '/report-monthly-earnings',
        browserTitle: 'Relatório de Ganhos no Mês',
        page: ReportMonthlyEarnings,
        roles: [Roles.Consultant]
    },
    {
        path: '/consultants',
        browserTitle: 'Consultores',
        colorBackgroundHeader:"#2e247a",
        page: Consultants,
        roles: [Roles.Admin, Roles.Marketing]
    }, {
        path: '/report-leads',
        browserTitle: 'Relatório de Leads',
        page: ReportLeads,
        roles: [Roles.Admin, Roles.Marketing],
    }, {
        path: '/search/:search',
        browserTitle: 'Busca geral',
        page: GeneralSearch,
        roles: [Roles.User],
    }, {
        path: '/search/',
        browserTitle: 'Busca geral',
        page: GeneralSearch,
        roles: [Roles.User],
    }, {
        path: '/SupportingMaterial',
        browserTitle: 'Material de Apoio',
        page: SupportingMaterial,
        roles: [Roles.Consultant,Roles.Admin,Roles.Marketing],
    }, {
        path: '/SupportingMaterialAdmin',
        browserTitle: 'Material de Apoio',
        page: SupportingMaterialAdmin,
        roles: [Roles.Admin,Roles.Marketing],
    },{
        path: '/SupportingMaterialAdmin/SupportingMaterialSubCategoryAdmin/:idcat',
        browserTitle: 'Material de Apoio - Subcategoria',
        page: SupportingMaterialSubCategoryAdmin,
        roles: [Roles.Admin,Roles.Marketing],
    },{
        path: '/BannerPopUpAdmin',
        browserTitle: 'Eventos e Novidades',
        page: BannerPopUpAdmin,
        roles: [Roles.Admin,Roles.Marketing],
    },{
        path: '/Partner/PartnerWebHook',
        browserTitle: 'WebHooks',
        page: PartnerWebHook,
        roles: [Roles.Admin,Roles.Partner],
    },{
        path: '/AuthorizedStore',
        browserTitle: 'Lojas Credenciadas',
        page: AuthorizedStore,
        roles: [Roles.Admin, Roles.Consultant, Roles.HeadOffice, Roles.BranchOffice], // Assuming only admins can register matrix
    },{
        path: '/AuthorizedStore/HeadOffice',
        browserTitle: 'Lojas Credenciadas',
        page: HeadOffice,
        roles: [Roles.Admin, Roles.Consultant], // Assuming only admins can register matrix
    },
    {
        path: '/AuthorizedStore/BranchOffice',
        browserTitle: 'Lojas',
        page: BranchOffice,
        roles: [Roles.Admin, Roles.Consultant, Roles.HeadOffice]
    },
    {
        path: '/AuthorizedStore/BranchOffice/:idHeadOffice',
        browserTitle: 'Lojas',
        page: BranchOffice,
        roles: [Roles.Admin, Roles.Consultant, Roles.HeadOffice]
    },
    {
        path: '/AuthorizedStore/Seller/:idBranchOffice',
        browserTitle: 'Vendedores',
        page: Seller,
        roles: [Roles.Admin, Roles.Consultant, Roles.HeadOffice, Roles.BranchOffice]
    },
    {
        path: '/Partner/PartnerStatusAndSubStatus',
        browserTitle: 'Status e SubStatus',
        page: PartnerStatusAndSubStatus,
        roles: [Roles.Admin,Roles.Partner],
    }
]

export default routes;
